module.exports = __webpack_public_path__ + "static/img/home2.e08ca0d.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home2.webp
// module id = ecR0
// module chunks = 3